import React from 'react';
import { CustomerIssueRow } from '../callCenterCustomerIssuesTypes';
import { PriorityBadge, StatusBadge, ViewButton, IssueCard } from '../../shared';
import sharedStyles from '../../shared/IssueTable.module.css';
import styles from './CustomerIssuesTable.module.css';

interface CustomerIssuesTableProps {
  rows: CustomerIssueRow[];
  onView?: (id: string) => void;
}

export const CustomerIssuesTable: React.FC<CustomerIssuesTableProps> = ({ rows, onView }) => {
  return (
    <IssueCard title="My Orders">
      <div className={sharedStyles.tableWrap}>
        <table className={sharedStyles.table}>
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>CUSTOMER</th>
              <th>ORDER #</th>
              <th>ISSUE TYPE</th>
              <th>PRIORITY</th>
              <th>STATUS</th>
              <th>ASSIGNED TO</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={sharedStyles.ticketId}>{row.ticketId}</td>
                <td className={sharedStyles.bold}>{row.customer}</td>
                <td>{row.orderId}</td>
                <td className={styles.issueType}>{row.issueType}</td>
                <td>
                  <PriorityBadge priority={row.priority} />
                </td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>{row.assignedTo}</td>
                <td>
                  <ViewButton onClick={() => onView?.(row.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </IssueCard>
  );
};
